import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function FounderStatement() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--fy-background-primary)' }}>
      {/* Header */}
      <header className="sticky top-0 z-40" style={{ backgroundColor: 'var(--fy-background-primary)', borderBottom: '1px solid var(--fy-border-subtle)' }}>
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2" style={{ color: 'var(--fy-text-secondary)' }} data-testid="back-btn">
            <ArrowLeft className="w-5 h-5" />
            Back
          </button>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center overflow-hidden" style={{ backgroundColor: 'var(--fy-background-secondary)' }}>
              <img src="https://customer-assets.emergentagent.com/job_kindplatform/artifacts/my73uiau_file_00000000f09c720c9463ab506718d330.png" alt="LikeKind" className="w-8 h-8 object-cover" />
            </div>
            <span className="font-bold" style={{ color: 'var(--fy-text-primary)' }}>LikeKind</span>
          </div>
          <div className="w-20"></div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-10">
        <h1 
          className="text-3xl sm:text-4xl font-bold mb-10" 
          style={{ color: 'var(--fy-text-primary)', fontFamily: 'Outfit' }}
          data-testid="page-title"
        >
          Founder's Letter
        </h1>

        <div className="space-y-6 leading-relaxed" style={{ color: 'var(--fy-text-secondary)' }}>
          <p>If you're reading this, you're already inside.</p>
          <p>So I'll keep this simple.</p>
          <p>This wasn't built to compete for your attention.<br/>It was built because too many things already do.</p>
          <p>At some point, platforms stopped helping people show up in real life and started replacing it. Not all at once. Just slowly.</p>
          <p>Plans turned into posts.<br/>Participation turned into watching.<br/>Being there turned into being seen.</p>
          <p>And most of us just adjusted to it without really thinking about it.</p>
          <p>I didn't build this because I think people are broken.<br/>I built it because I think the systems around them drifted.</p>

          <p className="text-lg font-medium" style={{ color: 'var(--fy-text-primary)' }}>
            LikeKind is meant to do one thing well:
          </p>
          <p className="text-lg font-medium" style={{ color: 'var(--fy-text-primary)' }}>
            Help people organize real things with real people in the real world.
          </p>
          <p>That's it.</p>

          <p>You can come in, see what's happening, join something, or start something.<br/>Then leave.</p>
          <p>Nothing here should make you feel like you need to stay.<br/>Nothing should make you feel bad for stepping away.</p>
          <p>There are no scores.<br/>No pressure to say more.<br/>No system quietly pushing you to keep going.</p>
          <p>If you show up, it matters.<br/>If you don't, nothing follows you around.</p>
          <p>That was intentional.</p>

          <p>A lot of products are designed to keep you inside them.<br/>This one should feel like it gets out of your way.</p>
          <p>Not because it doesn't care.<br/>Because it does.</p>

          <p>People will use this differently.<br/>Some will organize things.<br/>Some will join.<br/>Some will check in once in a while and that's enough.</p>
          <p>That's all fine.</p>

          <p>The only thing that really matters is that when you do use it, it feels clear.<br/>And it feels honest.</p>
          <p>No tricks.<br/>No manipulation.<br/>No pretending this is something it's not.</p>
          <p>Just a place to coordinate and show up if you want to.</p>

          <p className="font-medium" style={{ color: 'var(--fy-text-primary)' }}>
            That's the whole idea.
          </p>

          <div className="pt-8" style={{ borderTop: '1px solid var(--fy-border-subtle)' }}>
            <p className="text-lg" style={{ color: 'var(--fy-text-primary)', fontFamily: 'serif', fontStyle: 'italic' }}>
              — Cris
            </p>
          </div>
        </div>
      </main>

      <footer className="mt-16 py-8" style={{ borderTop: '1px solid var(--fy-border-subtle)' }}>
        <div className="max-w-3xl mx-auto px-4 text-center">
          <p style={{ color: 'var(--fy-text-disabled)' }}>© {new Date().getFullYear()} LikeKind Inc.</p>
        </div>
      </footer>
    </div>
  );
}
